module.exports = __webpack_public_path__ + "8afe6e2e3144cc92aabc94cddaccf830.jpg";